import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import { MissingValue } from 'components/misc/MissingValue';

/** The em dash a stored brief and its PDF both use for an empty value. */
export const EM_DASH = '—';

/** True where the brief writes an empty value as an em dash rather than the shared ASCII dash. */
export const EmDashPlaceholderContext = createContext(false);

/** The dimmed placeholder for an absent value, in the dash the surrounding brief uses. */
export function MeetingPrepMissingValue(): ReactNode {
    const emDash = useContext(EmDashPlaceholderContext);
    return emDash ? <span className="text-muted-foreground font-normal">{EM_DASH}</span> : <MissingValue />;
}

/** The mark for an absent value where the surrounding markup supplies its own styling. */
export function useEmptyValueMark(): string {
    return useContext(EmDashPlaceholderContext) ? EM_DASH : '-';
}
